import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetUserByCoachId = async function(userId, programId) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  const result = await queryThaisookViewBigQuery({
    info: 'get userlist by coach group',
    query: `
    with data as (
      select
        GM.groupId id,
        G.name,
        G.description,
        'admin' MK
      from
        thaisook_view.group_members GM
        join 
          thaisook_view.groups G
          on G.groupId = GM.groupId
      where
        GM.uid='${userId}'
        and GM.admin = true
    
      UNION ALL
    
      select
        G.groupId id,
        G.name,
        G.description,
        'owner' MK
      from
        thaisook_view.groups G
      where
        G.owner = '${userId}'
    )
    select 
      M.uid, 
      concat(U.firstname, ' ', U.lastname) name, 
      d.name groupName,
      phoneNumber,
      M.groupId,
      d.MK,
      P.name programName,
      U.pictureUrl,
      IF ('${programId}' = IF (PM.isCancelProgram or PM.isCompleteProgram, '', P.programId), 0, 
        if( '${programId}' = PM.programId, if(PM.isCancelProgram or PM.isCompleteProgram, 1, 0), 1) 
      ) allowAdd,
      IF (PM.isCancelProgram or PM.isCompleteProgram, '', P.programId) currentProgram,
      PM.programId joinProgram
    from 
      thaisook_view.group_members M 
      join thaisook_view.users U on M.uid = U.uid
      join data d on M.groupId = d.id
      left join thaisook_view.program P on P.programId = U.currentProgram
      left join thaisook_view.program_members PM on PM.uid=U.uid and PM.programId = '${programId}'
    order by allowAdd
    `
  });
  const resultObj = JSON.parse(result.data);
  return resultObj
};
export default bqGetUserByCoachId;
